/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable dot-notation */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useEffect, ChangeEvent, useRef } from 'react';
import { FormikHelpers, FormikProvider, useFormik } from 'formik';
import Swal from 'sweetalert2';
import Divider from '@mui/material/Divider';
import _ from 'lodash';

// icons
import { ReactComponent as Archive } from 'design_system/src/static/icons/archive.svg';
import { ReactComponent as Image } from 'design_system/src/static/icons/image.svg';
import { ReactComponent as Save } from 'design_system/src/static/icons/save.svg';
import { ReactComponent as Close } from 'design_system/src/static/icons/close-circle.svg';
import { ReactComponent as Search } from 'design_system/src/static/icons/search.svg';
import { ReactComponent as Position } from 'design_system/src/static/icons/gps.svg';
import { ReactComponent as Right } from 'design_system/src/static/icons/right-md.svg';

import { ReactComponent as Play } from 'design_system/src/static/icons/play-circle.svg';
import { ReactComponent as Pause } from 'design_system/src/static/icons/pause-circle.svg';

import { Button, Input, Typography, SideModal } from 'design_system/src';

// css
import { toasterOptions } from 'models/shared/enums/toaster.enum';
import { imagesDto } from 'models/inventory/interfaces/vehicle.interface';
import { toasterNotification } from 'models/shared/helpers/toasterNotification';
import { filterObjectByKeys } from 'models/shared/helpers/utils';
import {
	CreateVehicleDto,
	Vehicle,
	UpdateVehicleDto,
} from 'models/vehicles/interfaces/vehicles.interface';
import {
	createVehicle,
	updateVehicle,
} from 'models/vehicles/controllers/vehicles.controller';
import {
	fetchGeotiles,
	syncGeotiles,
} from 'models/geotile/controllers/geotile.controller';
import { commonErrorHandler } from 'models/shared/helpers/errors';
import { getImageUrl } from 'models/shared/helpers/imageUrl';
import { Geotile } from 'models/geotile/interfaces/geotile.interface';
import { VehicleStatusEnum } from 'models/vehicles/enums/vehicles.enum';
import { vehicleDefaults, vehicleValidationSchema } from './constants';

interface EditProps {
	open: boolean;
	setOpen: Function;
	values?: Partial<Vehicle> | null;
	setResult: Function;
}

function EditVehicle({ open, setOpen, values = null, setResult }: EditProps) {
	const [img, setImg] = useState<imagesDto>();
	const [tile, setTile] = useState<Geotile>();
	const [availableTiles, setAvailableTiles] = useState<Geotile[]>([]);
	const [loadingTiles, setLoadingTiles] = useState(false);
	const [initial, setInitial] = useState<UpdateVehicleDto | CreateVehicleDto>(
		vehicleDefaults,
	);
	const [modified, setModified] = useState<boolean>(false);
	const [showErrors, setShowErrors] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);

	const [fullOpen, setFullOpen] = useState<boolean>(false);
	const [query, setQuery] = useState();
	const fileInputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		requestGeotiles();
	}, []);

	const requestGeotiles = () => {
		setLoadingTiles(true);
		fetchGeotiles({
			isAssigned: false,
			query: query ?? undefined,
		})
			.then((tiles) => {
				setLoadingTiles(false);
				setAvailableTiles(tiles.data);
			})
			.catch((e) => {
				commonErrorHandler(e);
				setLoadingTiles(false);
			});
	};

	useEffect(() => {
		let initialValue = vehicleDefaults;
		if (values?._id) {
			const imgs =
				values.image && values.image.url
					? {
							view: getImageUrl(values.image.url),
							name: values.image.name,
					  }
					: undefined;
			setImg(imgs);

			setTile(values.tile);

			initialValue = filterObjectByKeys(
				values,
				Object.keys(vehicleDefaults) as any,
			);
		}

		setInitial(initialValue);
	}, [values]);

	const handleFiles = (e: ChangeEvent<HTMLInputElement>) => {
		const { files } = e.target;
		if (files) {
			const file = files.item(0);
			// eslint-disable-next-line no-plusplus
			if (file) {
				if (file.size > 10000000) {
					Swal.fire({
						text: 'La imagen no debe ser superior a 10mb',
						icon: 'warning',
						confirmButtonText: 'Aceptar',
					});
				} else {
					setImg({
						file,
						view: URL.createObjectURL(file),
					});
					setModified(true);
				}
			}
		}
		if (e.target) {
			e.target.value = '';
		}
	};

	const displayFormErrors = (form: any) => {
		if (Object.keys(form.errors)?.length)
			toasterNotification({
				msg: `Hay errores en los campos: ${Object.keys(form.errors).reduce(
					(acc, ele) => `${acc ? `${acc}, ` : ''}'${ele}'`,
					'',
				)}`,
				style: 'light',
				toasterType: toasterOptions.error,
			});
		setShowErrors(true);
	};

	const displayRequestErrors = (err: any) => {
		if (err.message === 'Vehicle already exists') {
			// eslint-disable-next-line no-param-reassign
			err =
				'Este internalId ya existe, si es una moto recuperada marque la anterior como tal para registrar la nueva moto';
		}
		toasterNotification({
			msg:
				typeof err === 'string'
					? err
					: typeof err.message === 'string'
					? err.message
					: 'Ocurrio un error',
			toasterType: toasterOptions.error,
			style: 'light',
		});
		setLoading(false);
	};

	const onSubmit = (
		vals: UpdateVehicleDto | CreateVehicleDto,
		form: FormikHelpers<UpdateVehicleDto | CreateVehicleDto>,
	) => {
		setLoading(true);

		if (values?._id) {
			const payload = { ...vals };
			if (values.tile?._id !== tile?._id) payload.tile = tile?._id;
			updateVehicle(payload, values._id, img)
				.then((ele) => {
					setLoading(false);
					setOpen(false);
					setResult(ele);
					setImg(undefined);
				})
				.catch((err) => {
					displayRequestErrors(err);
				});
		} else {
			createVehicle({ ...vals, tile: tile?._id } as CreateVehicleDto, img)
				.then((ele) => {
					setLoading(false);
					setOpen(false);
					setResult(ele);
					setImg(undefined);
				})
				.catch((err) => {
					displayRequestErrors(err);
				});
		}
	};
	const changeVehicleStatus = () => {
		setLoading(true);

		if (values?._id) {
			updateVehicle(
				{
					status:
						values.status === VehicleStatusEnum.active
							? VehicleStatusEnum.inactive
							: VehicleStatusEnum.active,
				},
				values._id,
				img,
			)
				.then((ele) => {
					setLoading(false);
					setOpen(false);
					setResult(ele);
				})
				.catch((err) => {
					displayRequestErrors(err);
				});
		}
	};

	const sincronizarTile = () => {
		setLoadingTiles(true);
		syncGeotiles()
			.then((ele) => {
				toasterNotification({
					msg: `Se han agregado ${ele.created} GPSs`,
					toasterType: toasterOptions.success,
					style: 'light',
				});
				requestGeotiles();
			})
			.catch((e) => {
				setLoadingTiles(false);
				commonErrorHandler(e);
			});
	};

	const form = useFormik<UpdateVehicleDto | CreateVehicleDto>({
		initialValues: initial,
		validationSchema: vehicleValidationSchema,
		onSubmit,
		enableReinitialize: true,
		validateOnMount: true,
	});

	return (
		initial && (
			<SideModal
				open={open}
				setOpen={setOpen}
				fullOpen={fullOpen}
				setFullOpen={setFullOpen}
			>
				<FormikProvider value={form}>
					<div className="flex_header">
						<Typography
							scale="heading4"
							weight="600"
							textColor="neutral_900"
							className="m_b_lg m_t_md"
						>
							{values?._id ? 'Editar Activo' : 'Crear nuevo Activo'}
						</Typography>
						<Divider />
					</div>
					<div className="flex_body p_y_lg p_x_sm overflow_x_hidden">
						<div className="flex_center">
							<div
								className={`dso_card bg_neutral_0 flex_center_col m_b_xl p_md pos_relative ${
									!img ? 'border_primary_200 border_dotted' : ''
								}`}
								style={{
									width: '200px',
									minHeight: '240px',
								}}
							>
								{img && (
									<Close
										className="text_red_300 dim_lg delete_photo pos_absolute"
										style={{
											top: '8px',
											right: '8px',
											zIndex: 10,
											cursor: 'pointer',
										}}
										onClick={() => {
											setImg(undefined);
										}}
									/>
								)}
								<Typography
									scale="xsmall"
									weight="600"
									textColor={img ? 'neutral_900' : 'primary_300'}
									className="text_center m_b_md"
								>
									{img ? 'Foto' : 'AÑADIR FOTO'}
								</Typography>
								<div
									className="dso_card_img m_b_md bg_neutral_200 display_flex overflow_hidden"
									style={{
										width: '160px',
										height: '160px',
										borderRadius: '8px',
										justifyContent: 'center',
										alignItems: 'center',
										border: img ? 'none' : '2px dashed var(--primary_300)',
										position: 'relative',
									}}
								>
									{img ? (
										<img
											src={img.view}
											alt="Vehicle preview"
											style={{
												width: '100%',
												height: '100%',
												objectFit: 'cover',
												pointerEvents: 'none',
											}}
										/>
									) : (
										<Image className="dim_xl text_primary_300 border_transparent" />
									)}
									<input
										ref={fileInputRef}
										type="file"
										accept="image/png, image/jpeg"
										onChange={handleFiles}
										style={{
											position: 'absolute',
											width: '100%',
											height: '100%',
											opacity: 0,
											cursor: 'pointer',
											top: 0,
											left: 0,
											zIndex: 10,
											pointerEvents: 'auto',
										}}
									/>
								</div>
							</div>
						</div>
						<Input
							onBlur={form.handleBlur}
							error={
								!!form.errors.internalId &&
								(form.getFieldMeta('internalId').touched || showErrors)
							}
							subtitle={
								form.getFieldMeta('internalId').touched || showErrors
									? (form.errors.internalId as string | undefined)
									: undefined
							}
							title="Identificador único"
							icon={<Archive />}
							placeholder="Identificación activo"
							name="internalId"
							type="text"
							className="m_b_xs w_100_per"
							value={form.values.internalId}
							onChange={(e: any) => {
								form.handleChange(e);
							}}
						/>
						<Input
							onBlur={form.handleBlur}
							error={
								!!form.errors.description &&
								(form.getFieldMeta('description').touched || showErrors)
							}
							subtitle={
								form.getFieldMeta('description').touched || showErrors
									? form.errors.description
									: undefined
							}
							placeholder="Descripcion"
							title="Descripción"
							icon={<Archive />}
							name="description"
							type="text"
							className="m_b_xs w_100_per"
							value={form.values.description}
							onChange={form.handleChange}
						/>
						<div
							className="br_xs border_1 border_solid border_neutral_400 p_md display_flex flex_gap_md flex_align_center m_t_xl cursor_pointer"
							role="button"
							onClick={() => {
								setFullOpen(true);
							}}
							onKeyDown={() => {
								setFullOpen(true);
							}}
							tabIndex={0}
						>
							<Position className="dim_md" />

							<Typography scale="medium" weight="400" className="flex_1">
								{tile ? `GPS: ${tile.name}` : 'Asignar GPS'}
							</Typography>
							<Right className="dim_md" />
						</div>
					</div>
					<div className="flex_footer">
						{values?._id ? (
							<Button
								scale="small"
								orientation="right"
								icon={
									values.status === VehicleStatusEnum.active ? (
										<Pause />
									) : (
										<Play />
									)
								}
								className="m_b_md w_100_per"
								color={
									values.status === VehicleStatusEnum.active ? 'red' : 'green'
								}
								type="submit"
								onClick={() => {
									changeVehicleStatus();
								}}
								disabled={loading}
							>
								{values.status === VehicleStatusEnum.active
									? 'Desactivar'
									: 'Reactivar'}{' '}
								Activo
							</Button>
						) : null}
						<Button
							scale="small"
							orientation="right"
							icon={<Save />}
							className="m_b_xs w_100_per"
							type="submit"
							onClick={() => {
								displayFormErrors(form);
								form.handleSubmit();
							}}
							disabled={loading || (!form.dirty && !modified)}
						>
							Guardar
						</Button>
					</div>
				</FormikProvider>
				<div>
					<div className="flex_header">
						<Typography
							scale="heading4"
							weight="600"
							textColor="neutral_900"
							className="m_b_lg m_t_md"
						>
							Seleccionar GPS
						</Typography>
						<Divider />
						<div className="display_flex flex_gap_md w_100_per flex_align_center">
							<Input
								title=""
								placeholder="Búsqueda"
								className="flex_1"
								name="search"
								type="text"
								value={query}
								onChange={(e: any) => setQuery(e.target.value)}
							/>
							<Button
								type="submit"
								scale="small"
								icon={<Search />}
								className=""
								onClick={requestGeotiles}
								variant="icon"
								subvariant="fill"
							/>
						</div>
					</div>
					<div className="flex_body p_r_xs overflow_x_hidden">
						{loadingTiles ? (
							<Typography scale="medium" weight="400" textColor="neutral_900">
								Cargando Dispositivos
							</Typography>
						) : availableTiles?.length ? (
							<div className="display_flex flex_col flex_gap_xs">
								{availableTiles.map((dev) => (
									<div
										className="br_xs border_1 border_solid border_neutral_400 p_md display_flex flex_gap_md flex_align_center cursor_pointer"
										key={dev._id}
										role="button"
										onClick={() => {
											setFullOpen(false);
											setQuery(undefined);
											setTile(dev);
											setModified(true);
										}}
										onKeyDown={() => {
											setFullOpen(false);
											setQuery(undefined);
											setTile(dev);
											setModified(true);
										}}
										tabIndex={0}
									>
										<Position className="dim_md" />
										<div className="display_flex flex_col flex_gap_xs">
											<Typography scale="medium" weight="400" className="">
												Nombre: {dev.name ?? '--'}
											</Typography>
											<Typography
												scale="small"
												weight="400"
												textColor="neutral_600"
											>
												UUID: {dev.uuid ?? '--'}
											</Typography>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="flex_center flex_col flex_gap_md">
								<Typography scale="medium" weight="400" textColor="neutral_900">
									No se encontraron dispositivos, si se registraron nuevos,
									porfavor sincronizalos
								</Typography>
								<Button
									scale="small"
									onClick={() => {
										sincronizarTile();
									}}
									disabled={loadingTiles}
								>
									Sincronizar GPS
								</Button>
							</div>
						)}
					</div>
				</div>
			</SideModal>
		)
	);
}

export default EditVehicle;
